Customer.Filters ||= {}

class Customer.Filters.EditFolderView extends Backbone.View
  template: JST['backbone/templates/customer/filters/edit_folder']
  className: 'customer-folder-edit'

  events:
    'change #filter_title_input': 'updateName'
    'blur #filter_title_input': 'updateName'
    'click .customer-filters-edit': 'onOperatorAction'

  initialize: (options = {}) ->
    @actualFolder = options.folder
    @folder = options.folder.clone()
    @availableFolders = options.availableFolders
    @modal =
      buttons: [@_cancelButton(), @_saveButton()]
      title: if options.isNew then @_newFolderModalTitle() else @_editFolderModalTitle()
    @colorPickerView = new Customer.Filters.ColorPickerView({color: @folder.get('color')})
    @visibilityView = new Customer.Filters.VisibilityView
      title: I18n.t('customer.dashboard.filters.filter_collections.visibility')
      visibility: {user_id: @folder.get('user_id'), global: @folder.isGlobal()}
      canManageGlobal: canManageGlobal: options.canManageGlobal
      editable: true

    @listenTo(@visibilityView, 'toggleVisibility', @_onToggleVisibility)

  onOperatorAction:->
    @_keepCustomerSessionAlive()

  _cancelButton: ->
    title: I18n.t 'customer.dashboard.filters.cancel'
    event: 'closeModal'

  _saveButton: ->
    title: I18n.t 'customer.dashboard.filters.save'
    event: 'onSave'

  _newFolderModalTitle: ->
    I18n.t 'customer.dashboard.filters.folder.creation.header'

  _editFolderModalTitle: ->
    _.escape("#{I18n.t('customer.dashboard.filters.edition.header')} #{@folder.get('name')}")

  render: ->
    @$el.html @template
      folder: @folder
      availableFolders: @availableFolders
    @_selectFolderOption()
    @_renderColorPicker()
    @_renderVisibilityView()
    @

  updateName: (event) =>
    @folder.set 'name', $(event.target).val()
    if ($(event.target).val() == '')
      $(event.target).addClass('invalid_folder_name')
    else
      $(event.target).removeClass('invalid_folder_name')

  onSave: =>
    @_keepCustomerSessionAlive()
    @folder.set('name', @$el.find('#filter_title_input').val())
    return if (@folder.get('name') == '')
    @_updateColor()
    @_setFilterFolderId()
    @actualFolder.set
      name: @folder.get 'name'
      color: @folder.get 'color'
      isGlobal: @folder.get 'isGlobal'
      old_filter_collection_id: @folder.get 'old_filter_collection_id'
      filter_collection_id: @folder.get 'filter_collection_id'
      user_id: @folder.get 'user_id'
    @actualFolder.update (folder) => @trigger('save', folder)
    @modalTab.destroy()

  closeModal: (triggerKeepAlive) =>
    @_keepCustomerSessionAlive() if triggerKeepAlive
    @modalTab.destroy()

  _setFilterFolderId: ->
    @folder.set('old_filter_collection_id', @folder.get('filter_collection_id'))
    filterFolderId = @$el.find('.parentFolder input[type="radio"]:checked').val()
    filterFolderId = null if filterFolderId == 'null'
    @folder.set('filter_collection_id', filterFolderId)

  updateAvailableFolders: (folders) ->
    @availableFolders = folders
    @_updateColor()
    @render()

  _selectFolderOption: ->
    @$el.find(".parentFolder input[value=#{@folder.get('filter_collection_id')}]").prop('checked', true)

  _renderColorPicker: ->
    colorPickerViewEl = @colorPickerView.render().el
    $(colorPickerViewEl).addClass('inline-structure')
    @$('.colors-container').empty().append(colorPickerViewEl)

  _renderVisibilityView: ->
    visibilityViewEl = @visibilityView.render().el
    $(visibilityViewEl).addClass('inline-structure span6')
    @$('.is-global-container').empty().append(visibilityViewEl)

  _onToggleVisibility: ->
    visibility = @visibilityView.getVisibility()
    @folder.set('isGlobal', visibility.global)
    @folder.set('user_id', visibility.user_id)
    @trigger('folder:toggleVisibility', @folder)

  _updateColor: ->
    @folder.set('color', @colorPickerView.getColor())

  _keepCustomerSessionAlive:->
    Backbone.trigger 'customerSession:keepAlive'
